import React from 'react';
import Screenshots from '../components/Screenshots';
import Footer from '../components/Footer';
import { Link } from 'react-router-dom';
import { FaArrowLeft } from 'react-icons/fa';

const ScreenshotsPage = () => {
    return (
        <div className="screenshots-page">
            <nav className="navbar" style={{ padding: '1rem 0', background: 'var(--background)' }}>
                <div className="container">
                    <Link to="/" style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', fontWeight: 'bold', color: 'var(--primary)' }}>
                        <FaArrowLeft /> Ana Sayfaya Dön
                    </Link>
                </div>
            </nav>
            <div style={{ maxWidth: '1200px', margin: '0 auto', padding: '0 1rem' }}>
                <Screenshots />
            </div>
            <Footer />
        </div>
    );
};

export default ScreenshotsPage;
